import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "./api";

function Stat({ label, value, testid }) {
  return (
    <div className="rounded-[1.5rem] bg-white border border-border p-6" data-testid={testid}>
      <p className="text-charcoal/55 text-xs font-semibold uppercase tracking-wider">{label}</p>
      <p className="mt-2 font-poppins font-bold text-3xl text-charcoal">{value}</p>
    </div>
  );
}

export default function Dashboard() {
  const [d, setD] = useState(null);
  useEffect(() => { api().get("/admin/dashboard").then(r => setD(r.data)); }, []);
  if (!d) return <p className="text-charcoal/60">Loading…</p>;
  const booked = d.founding_booked;
  const total = d.founding_slots_total;
  const pct = Math.min(100, (booked / total) * 100);
  return (
    <div className="space-y-6" data-testid="admin-dashboard">
      <div className="rounded-[2rem] bg-plum text-cream p-8 md:p-10">
        <p className="text-marigold text-xs font-semibold uppercase tracking-wider">Phase 1 goal</p>
        <p className="mt-2 font-poppins font-bold text-3xl md:text-4xl" data-testid="phase1-goal">
          {booked} of {total} founding community events booked
        </p>
        <div className="mt-5 h-3 w-full rounded-full bg-cream/15 overflow-hidden">
          <div className="h-full bg-coral" style={{ width: `${pct}%` }} />
        </div>
        <p className="mt-3 text-cream/70 text-sm">{d.founding_slots_remaining} founding slot(s) remaining</p>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <Stat label="Total leads" value={d.total_leads} testid="stat-total" />
        <Stat label="Ready for outreach" value={d.ready_for_outreach} testid="stat-ready" />
        <Stat label="Outreach this week" value={d.outreach_this_week} testid="stat-outreach" />
        <Stat label="Follow-ups due" value={d.followups_due} testid="stat-followups" />
        <Stat label="Discovery scheduled" value={d.discovery_scheduled} testid="stat-discovery" />
        <Stat label="Proposals outstanding" value={d.proposals_outstanding} testid="stat-proposals" />
        <Stat label="Revenue booked" value={`$${d.revenue_booked}`} testid="stat-revenue" />
        <Stat label="Events completed" value={d.events_completed} testid="stat-completed" />
      </div>

      <div className="rounded-[1.75rem] bg-white border border-border p-6">
        <h3 className="font-poppins font-bold text-lg mb-4">Pipeline snapshot</h3>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
          {d.stages_order.map((s) => (
            <Link key={s} to={`/admin/leads?stage=${encodeURIComponent(s)}`}
              className="rounded-2xl bg-cream border border-border p-4 hover:-translate-y-0.5 transition-transform">
              <p className="text-charcoal/60 text-xs">{s}</p>
              <p className="font-poppins font-bold text-2xl text-charcoal">{d.stages[s] || 0}</p>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
